<template>
  <div class="card-details-container">
    <!-- 查询头部 -->
    <div class="search-header">
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="手机号">
          <el-input
            v-model="searchForm.phone"
            placeholder="请输入手机号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input
            v-model="searchForm.name"
            placeholder="请输入姓名"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 数据表格 -->
    <el-table :data="tableData" border style="width: 100%" v-loading="loading">
      <el-table-column
        type="index"
        label="序号"
        width="60"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="CreateTime"
        label="兑换时间"
        width="180"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="TelPhone"
        label="兑换手机号"
        width="150"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="UserName"
        label="兑换姓名"
        width="120"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="CreateBy"
        label="用户名称"
        width="120"
        align="center"
      ></el-table-column>
      <el-table-column prop="Price" label="初始金额" width="120" align="center">
      </el-table-column>
      <el-table-column prop="SumPrice" label="余额" width="120" align="center">
      </el-table-column>
      <el-table-column
        prop="Code"
        label="卡号"
        min-width="180"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="EnterCompanyName"
        label="录入公司"
        show-overflow-tooltip
        width="100"
      ></el-table-column>
      <el-table-column
        prop="EnterPersonName"
        label="录入人员"
        show-overflow-tooltip
        width="100"
      ></el-table-column>
      <el-table-column label="操作" width="100" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="handleTurnOff(scope.row)"
          >
            手动扣款
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        style="float: right"
      >
      </el-pagination>
    </div>

    <!-- 工会卡手动扣款 弹窗 -->
    <el-dialog
      title="工会卡手动扣款"
      :visible.sync="dialogVisible"
      width="600px"
    >
      <el-form
        ref="cardForm"
        :model="formData"
        :rules="formRules"
        label-width="100px"
        class="form-container"
      >
        <el-form-item label="卡号" prop="Code">
          <el-input
            v-model="formData.Code"
            placeholder="卡号"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="场馆" prop="VenueId">
          <el-select
            v-model="formData.VenueId"
            filterable
            remote
            :remote-method="getVenue"
            @change="onVenueChange"
            style="width: 100%"
            placeholder="请选择场馆"
          >
            <el-option
              v-for="item in venueList"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订场" prop="VenueCourtId">
          <el-select
            :disabled="!formData.VenueId"
            v-model="formData.VenueCourtId"
            filterable
            remote
            :remote-method="getCourt"
            style="width: 100%"
            placeholder="请选择订场"
          >
            <el-option
              v-for="item in courtList"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="金额" prop="amount">
          <el-input-number
            v-model="formData.amount"
            :min="0"
            :precision="2"
            :step="0.01"
            placeholder="请输入金额"
            style="width: 100%"
          ></el-input-number>
          <div style="color: #909399; font-size: 12px; margin-top: 5px">
            当前余额：{{ formData.SumPrice || 0 }}元
          </div>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            type="textarea"
            v-model="formData.Remark"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="submitForm">
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCardHolderDetail, deductCardAmount } from "@/api/cardHolder/member";
import { getStadiumData, getCourtData } from "@/api/stadium/stadium";

export default {
  name: "CardDetails",
  props: {
    WxUserInfoId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      // 搜索表单
      searchForm: {
        phone: "",
        name: "",
      },
      // 表格数据
      tableData: [],
      // 加载状态
      loading: false,
      // 分页信息
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      // 弹窗相关
      dialogVisible: false,
      submitLoading: false,
      formData: {},
      formRules: {
        Code: [{ required: true, message: "卡号不能为空", trigger: "blur" }],
        VenueId: [{ required: true, message: "请选择场馆", trigger: "change" }],
        VenueCourtId: [
          { required: true, message: "请选择订场", trigger: "change" },
        ],
        amount: [
          { required: true, message: "请输入金额", trigger: "blur" },
          {
            type: "number",
            min: 0.01,
            message: "金额必须大于0",
            trigger: "blur",
          },
        ],
      },
      // 场馆相关数据
      venueList: [],
      courtList: [],
    };
  },
  created() {
    this.fetchData();
    this.getVenue();
  },
  methods: {
    // 手动扣款
    handleTurnOff(row) {
      this.dialogVisible = true;
      this.formData = {
        Code: row.Code,
        VenueId: "",
        VenueCourtId: "",
        amount: 0,
        Remark: "",
        SumPrice: row.SumPrice, // 保存当前卡片余额
      };
      this.$nextTick(() => {
        this.$refs["cardForm"].clearValidate();
      });
    },
    // 获取场馆列表
    getVenue(val = "") {
      getStadiumData({
        key: val,
      }).then((res) => {
        this.venueList = res.data.response;
      });
    },
    // 场馆改变事件
    onVenueChange() {
      this.formData.VenueCourtId = "";
      this.courtList = [];
      this.getCourt();
    },
    // 获取订场列表
    getCourt(val = "", Id = this.formData.VenueId) {
      if (!Id) {
        this.courtList = [];
        this.formData.VenueCourtId = "";
        return;
      }
      getCourtData({
        Id: Id,
        key: val,
      }).then((res) => {
        this.courtList = res.data.response;
      });
    },
    // 提交表单
    submitForm() {
      this.$refs.cardForm.validate((valid) => {
        if (valid) {
          // 验证余额是否足够
          if (this.formData.amount > this.formData.SumPrice) {
            this.$message({
              message: `扣款金额不能超过卡片余额！当前余额：${this.formData.SumPrice}元`,
              type: "warning",
            });
            return;
          }

          this.submitLoading = true;

          // 构建提交数据
          const selectedVenue = this.venueList.find(
            (item) => item.Id === this.formData.VenueId
          );
          const selectedCourt = this.courtList.find(
            (item) => item.Id === this.formData.VenueCourtId
          );

          const submitData = {
            Code: this.formData.Code,
            VenueId: this.formData.VenueId,
            VenueName: selectedVenue ? selectedVenue.Name : "",
            VenueCourtId: this.formData.VenueCourtId,
            VenueCourtName: selectedCourt ? selectedCourt.Name : "",
            Price: this.formData.amount,
            Remark: this.formData.Remark || "",
            TimeStamp: new Date().getTime(),
          };

          // 实际API调用示例（需要根据实际API接口调整）:
          deductCardAmount(submitData)
            .then((res) => {
              this.submitLoading = false;
              if (res.data.success) {
                this.$message({
                  message: res.data.msg || "扣款成功",
                  type: "success",
                });
                this.dialogVisible = false;
                this.fetchData(); // 刷新数据
              } else {
                this.$message({
                  message: res.data.msg || "扣款失败",
                  type: "error",
                });
              }
            })
            .catch((error) => {
              this.submitLoading = false;
              console.error("扣款失败:", error);
              this.$message({
                message: "扣款失败，请稍后重试",
                type: "error",
              });
            });
        }
      });
    },
    // 获取表格数据
    fetchData() {
      this.loading = true;
      const params = {
        wxUserInfoId: this.WxUserInfoId,
        page: this.pagination.currentPage,
        intPageSize: this.pagination.pageSize,
        phone: this.searchForm.phone,
        name: this.searchForm.name,
      };

      getCardHolderDetail(params)
        .then((res) => {
          if (
            res.data &&
            res.data.success &&
            Array.isArray(res.data.response.data)
          ) {
            this.tableData = res.data.response.data || [];
            this.pagination.total = res.data.response.dataCount || 0;
          } else {
            this.$message.error(response.msg || "获取数据失败");
          }
        })
        .catch((error) => {
          this.$message.error("获取数据失败，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 处理查询
    handleSearch() {
      this.pagination.currentPage = 1;
      this.fetchData();
    },
    // 重置查询条件
    resetSearch() {
      this.searchForm = {
        phone: "",
        name: "",
      };
      this.handleSearch();
    },
    // 处理每页显示数量变化
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.fetchData();
    },
    // 处理页码变化
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.fetchData();
    },
  },
};
</script>

<style scoped>
.card-details-container {
  padding: 20px;
}

.search-header {
  margin-bottom: 20px;
  background-color: #fff;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}
</style>
